var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 6,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9228 21.2695L23.6543 16.5H19.0781V13.4062C19.0781 12.1011 19.7162 10.8281 21.7658 10.8281H23.8477V6.76758C23.8477 6.76758 21.9592 6.44531 20.1545 6.44531C16.384 6.44531 13.9219 8.73018 13.9219 12.8648V16.5H9.73242V21.2695H13.9219V32.8002C14.763 32.9323 15.6234 33 16.5 33C17.3766 33 18.237 32.9323 19.0781 32.8002V21.2695H22.9228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon01);
export default __webpack_public_path__ + "static/media/social-icon-01.3624280dd87d141b604dec0e626b913b.svg";
export { ForwardRef as ReactComponent };